<!--
 * @Author: 王佳宾
 * @Date: 2022-09-29 13:30:42
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-06-11 16:51:20
 * @Description: 角色管理
 * @FilePath: \web\src\views\userManager\RoleManagement.vue
-->
<template>
  <section class="role-management">
    <a-tabs v-model:activeKey="activeKey" class="role-management-tabs">
      <a-tab-pane v-for="item in tabsList" :key="item.key"
        :tab="item.name" v-bind="item.option">
        <component :is="item.component"></component>
      </a-tab-pane>
    </a-tabs>
    <!-- <Role /> -->
    <!-- 角色管理 -->
  </section>
</template>

<script setup>
import { onMounted, ref, reactive, getCurrentInstance, } from 'vue';
import config from '@/config/config';
import Role from '@/components/DataManagement/roleManagement/roleManagement.vue';

const activeKey = ref('1');

const tabsList = [
  {
    key: '1',
    name: '角色管理',
    option: {
      forceRender: true,
    },
    component: Role,
  },
];

</script>

<style lang='scss'>
.role-management {
  background-color: rgba(179, 150, 92, 0.05);
  height: 100%;

  /* tabs */
  .role-management-tabs {
    height: 100%;

    /* 头 */
    .ant-tabs-top-bar {
      height: 0.5rem;
    }

    /* 内容区 */
    .ant-tabs-content {
      height: calc(100% - 0.5rem);

      .ant-tabs-tabpane {
        height: 100%;
      }
    }

    .ant-tabs {
      overflow: inherit;
    }

    .ant-tabs-nav-container {
      // background-color: rgba(10, 7, 0, 0.4);
    }

    .ant-tabs-ink-bar {
      background-color: transparent;
    }

    .ant-tabs-nav {
      .ant-tabs-tab:active {
        color: #fff;
        background-color: rgba(43, 34, 8, 0.7);
      }

      .ant-tabs-tab:hover {
        color: #fff;
        background-color: rgba(43, 34, 8, 0.7);
      }
    }

    .ant-tabs-bar {
      margin: 0;
      border-bottom: none;

      .ant-tabs-tab {
        color: rgba(255, 255, 255, 0.6);
        font-size: 0.16rem;
      }

      .ant-tabs-tab-active {
        color: #fff;
      }
    }
  }
}
</style>